module.exports = __webpack_public_path__ + "static/media/nollytime.9dfb7145.png";